import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
	const gridResults = document.querySelector(
		'#results-slider .grid-results .swiper-wrapper'
	);

	if (gridResults) {
		const gridResultsAmount = gridResults.dataset.totalResults;
		// results slider
		const resultsSwiper = new Swiper('#results-slider .grid-results', {
			modules: [Navigation, Pagination, A11y],
			navigation: {
				nextEl: '#results-slider .arrow-next-alt',
				prevEl: '#results-slider .arrow-prev-alt',
			},
			// pagination: {
			// 	el: '#results-slider .swiper-pagination',
			// 	clickable: true,
			// },
			a11y: true,
			autoHeight: true,
			keyboardControl: true,
			grabCursor: false,
			watchOverflow: true,
			loop: true,
			breakpoints: {
				320: {
					slidesPerView: 1,
					slidesPerGroup: 1,
				},
				768: {
					slidesPerView: 1,
					spaceBetween: 30,
					slidesPerGroup: 1,
					allowTouchMove: true,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 21,
					slidesPerGroup: 3,
					allowTouchMove: gridResults > 3,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 30,
					slidesPerGroup: 3,
				},
				// 1200: {
				// 	slidesPerView: 4,
				// 	pagination: false,
				// 	slidesPerGroup: 4,
				// 	spaceBetween: 45,
				// 	loop: gridResultsAmount > 4,
				// },
				// 1440: {
				// 	slidesPerView: 5,
				// 	slidesPerGroup: 5,
				// 	loop: gridResultsAmount > 5,
				// },
			},
		});

		if( window.matchMedia('(min-width: 992px)').matches ) {
			if( gridResultsAmount <=3 ) {
				const arrow_prev_alt = document.querySelector('#results-slider .arrow-prev-alt');
				const arrow_next_alt = document.querySelector('#results-slider .arrow-next-alt');
				const portrait = window.matchMedia("(orientation: portrait)");
				const landscape = window.matchMedia("(orientation: landscape)");

				arrow_prev_alt.classList.add('d-lg-none');
				arrow_next_alt.classList.add('d-lg-none');
			}
		}

		if( window.matchMedia('(max-width: 991px)').matches ) {
			if( gridResultsAmount <=3 ) {
				const arrow_prev_alt = document.querySelector('#results-slider .arrow-prev-alt');
				const arrow_next_alt = document.querySelector('#results-slider .arrow-next-alt');
				const landscape = window.matchMedia("(orientation: landscape)");

				landscape.addEventListener("change", (e) => {
					if ( e.matches ) {
						arrow_prev_alt.classList.add('d-lg-none');
						arrow_next_alt.classList.add('d-lg-none');
					}
				});

			}
		}

		// Commented - might use in the future
		// if( window.matchMedia('(min-width: 992px)').matches ) {
		// 	if( gridResultsAmount <=3 ) {
		// 		const arrow_prev_alt = document.querySelector('#results-slider .arrow-prev-alt');
		// 		const arrow_next_alt = document.querySelector('#results-slider .arrow-next-alt');
		// 		const portrait = window.matchMedia("(orientation: landscape)");

		// 		arrow_prev_alt.classList.add('d-none');
		// 		arrow_next_alt.classList.add('d-none');

		// 		portrait.addEventListener("change", (e) => {
		// 			if ( e.matches ) {
		// 				arrow_prev_alt.classList.remove('d-none');
		// 				arrow_next_alt.classList.remove('d-none');
		// 			}
		// 		});
		// 	}
		// }

		// if( window.matchMedia('(max-width: 991px)').matches ) {
		// 	if( gridResultsAmount <=3 ) {
		// 		const arrow_prev_alt = document.querySelector('#results-slider .arrow-prev-alt');
		// 		const arrow_next_alt = document.querySelector('#results-slider .arrow-next-alt');
		// 		const landscape = window.matchMedia("(orientation: landscape)");

		// 		landscape.addEventListener("change", (e) => {
		// 			if ( e.matches ) {
		// 				arrow_prev_alt.classList.add('d-none');
		// 				arrow_next_alt.classList.add('d-none');
		// 			}
		// 		});

		// 	}
		// }
	}
};
